import React from 'react';

/**
 * Pinterest's mark. Its red is the one colour here that is not ours to
 * restyle — it is how a person recognises the service they are connecting.
 */
export const PinterestLogo: React.FC<{ size?: number; className?: string }> = ({ size = 20, className }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden className={className}>
        <circle cx="20" cy="20" r="20" fill="#E60023" />
        <path
            fill="#FFFFFF"
            d="M20.6 8.5c-6.6 0-10 4.7-10 8.7 0 2.4.9 4.5 2.8 5.3.3.1.6 0 .7-.4l.3-1.1c.1-.4.1-.5-.2-.8-.6-.7-1-1.6-1-2.9 0-3.7 2.8-7.1 7.3-7.1 4 0 6.2 2.4 6.2 5.7 0 4.3-1.9 7.9-4.7 7.9-1.6 0-2.7-1.3-2.4-2.9.5-1.9 1.3-3.9 1.3-5.3 0-1.2-.7-2.2-2-2.2-1.6 0-2.9 1.7-2.9 3.9 0 1.4.5 2.4.5 2.4l-1.9 8.2c-.6 2.4-.1 5.4 0 5.7 0 .2.3.2.4.1.1-.2 1.6-2 2.1-3.9.1-.5.8-3.3.8-3.3.4.8 1.7 1.6 3.1 1.6 4 0 6.8-3.7 6.8-8.7 0-3.8-3.2-7.3-8-7.3z"
        />
    </svg>
);
